import tw from 'twin.macro';

export const labelStyle = tw`block text-sm font-semibold text-gray-700`;
export const errorStyle = tw`border-red-300 text-red-300 focus:(ring-red-300 border-red-300)`;
